export const HELP_QUICK_QUESTIONS = [
    "I moved a window off the screen",
    "How do I turn on scroll bars?",
    "How do I search for a player?",
    "How do I load my last search?",
    "How do I save or load a saved query?",
    "How do I filter the current list?",
    "How do I create or share a list?",
    "What is White Board?",
    "How do I see reports, notes, transactions, and files for one player?",
];

export const HELP_TOPICS = [
    {
        title: "Moved Window Off Screen",
        section: "Account [Purple Icon]",
        keywords: [
            "moved box off screen",
            "window missing",
            "reset window",
            "drag box",
            "lost box",
            "cannot find search",
            "purple man",
        ],
        questionExamples: [
            "I moved my movable box off the screen.",
            "My search box disappeared.",
            "How do I reset a window position?",
        ],
        answer: [
            "Open PurpleMan from the user/account button on the left sidebar.",
            "Press Window Reset, then choose the window you lost.",
            "Use Reset All if more than one movable window is in a bad spot.",
            "This resets saved positions for movable windows like S1 Search, S2 Search, Lists, Shared Lists, Saved Query, Alerts, Shared Notes, Overview, and Hard Data.",
        ],
    },
    {
        title: "Turn On OneLiner Scrollbars",
        section: "Account [Purple Icon]",
        keywords: [
            "scrollbar",
            "scroll bar",
            "grab scroll",
            "right side scroll",
            "mouse wheel",
            "one liner scroll",
            "show scrollbars",
        ],
        questionExamples: [
            "Can I grab a scroll bar instead of using the mouse wheel?",
            "How do I show scroll bars on the one liners?",
        ],
        answer: [
            "Open PurpleMan from the user/account button on the left sidebar.",
            "Press Scrollbars to switch OneLiner Scrollbars to On.",
            "The main, Notes, and Reports one-liners will show a draggable scrollbar on the right side.",
            "This setting is Off by default and only changes your own browser.",
        ],
    },
    {
        title: "AutoScroll On The OneLiner",
        section: "Account [Purple Icon]",
        keywords: ["autoscroll", "auto scroll", "selected player", "jump", "one liner"],
        questionExamples: ["Why does the list jump to my selected player?", "How do I stop auto scrolling?"],
        answer: [
            "Open PurpleMan from the user/account button.",
            "Use the AutoScroll button to turn OneLiner AutoScroll On or Off.",
            "When it is On, the main one-liner scrolls to the selected player after sorting or player changes.",
        ],
    },
    {
        title: "Sign Out Or Extend Time",
        section: "Account [Purple Icon]",
        keywords: ["sign out", "logout", "log out", "extend", "session", "auto log out", "time"],
        questionExamples: ["How do I extend my session?", "Where do I sign out?"],
        answer: [
            "Open PurpleMan from the user/account button on the left sidebar.",
            "Use Extend to refresh your auto log-out time.",
            "Use Sign Out at the bottom of PurpleMan when you are done.",
        ],
    },
    {
        title: "Open A Tool Automatically On Sign In",
        section: "Account [Purple Icon]",
        keywords: ["open on sign in", "startup", "calendar opens", "default open", "login"],
        questionExamples: ["How do I choose what opens when I sign in?"],
        answer: [
            "Open PurpleMan from the user/account button.",
            "Use Open on Sign In to choose the first box that should open after login.",
            "Options include Calendar, Lists, Shared Lists, and Shared Notes.",
        ],
    },
    {
        title: "Regular Search S1",
        section: "Action Bar [Left Side]",
        keywords: [
            "s1",
            "regular search",
            "basic search",
            "last name",
            "first name",
            "school",
            "country",
            "position",
            "height",
            "team",
            "status",
            "date range",
        ],
        questionExamples: ["How do I search for a player?", "Where is regular search?"],
        answer: [
            "Press S1 on the left sidebar for Regular Search.",
            "Use the name, school, position, country, league team/status, height, and date fields to narrow results.",
            "Press Enter or the search button to run the search.",
            "Use the reset/recycle control if you want to clear the search fields and start over.",
        ],
    },
    {
        title: "Advanced Search S2",
        section: "Action Bar [Left Side]",
        keywords: [
            "s2",
            "advanced search",
            "transaction search",
            "event search",
            "scout search",
            "note search",
            "league search",
            "date search",
        ],
        questionExamples: ["How do I search transactions?", "How do I search by event or scout report?"],
        answer: [
            "Press S2 on the left sidebar for Advanced Search.",
            "Use the transaction area to search league/team/status/position changes by date range.",
            "Use the event area for event-based searches.",
            "Use scout/report or note search when you want a report or note driven result set.",
            "S2 searches can change the one-line view to the correct result type automatically.",
        ],
    },
    {
        title: "Last Search S3",
        section: "Action Bar [Left Side]",
        keywords: ["s3", "last search", "reload search", "previous search", "last list"],
        questionExamples: ["How do I load my last search?", "Can I get my previous results back?"],
        answer: [
            "Press S3 on the left sidebar.",
            "S3 loads your last saved search/list result and restores the correct one-liner style when possible.",
        ],
    },
    {
        title: "Filter The Current List",
        section: "Top Navigation Buttons",
        keywords: [
            "filter",
            "top filter",
            "find in list",
            "search current list",
            "records",
            "last name filter",
            "grade filter",
        ],
        questionExamples: ["How do I search only inside the current list?", "Why did my records count change?"],
        answer: [
            "Use the filter box at the top-left of the page to filter the current result set.",
            "Choose the field, then type what you want to find.",
            "The record count beside the filter updates as the current list narrows.",
            "Clear the filter text to return to the full current result set.",
        ],
    },
    {
        title: "Nationals, Americans, Globals, And V Filter Pills",
        section: "Top Navigation Buttons",
        keywords: [
            "nationals",
            "american",
            "globals",
            "nationalized",
            "v filter",
            "nip",
            "pill",
            "orange",
        ],
        questionExamples: ["What do the colored pills do?", "How do I show only Nationals?"],
        answer: [
            "The colored pills filter the current list by player category.",
            "Nationals shows N players, American shows U/blank American players, Globals shows G players, and Nationalized Americans shows V players.",
            "Click the active pill again to remove that category filter.",
            "If a loaded list locks the pills, clear or change the loaded list/search first.",
        ],
    },
    {
        title: "Lists L1",
        section: "Action Bar [Left Side]",
        keywords: [
            "l1",
            "list",
            "my list",
            "quick list",
            "create list",
            "add player",
            "remove player",
            "share list",
            "delete list",
            "rename list",
        ],
        questionExamples: ["How do I create a list?", "How do I add this player to a list?", "How do I share my list?"],
        answer: [
            "Press L1 on the left sidebar to open your Lists box.",
            "Click a list name to load that list as the current result set.",
            "Use the add/remove controls in the list row to add or remove the active player.",
            "Use the share control on a list to choose who can receive it.",
            "Use the edit controls when you need to rename, delete, or manage a list.",
        ],
    },
    {
        title: "Shared Lists L2",
        section: "Action Bar [Left Side]",
        keywords: ["l2", "shared list", "list sent to me", "load shared list"],
        questionExamples: ["Where are lists that someone shared with me?", "How do I open a shared list?"],
        answer: [
            "Press L2 on the left sidebar to open Shared Lists.",
            "Choose a shared list to load those players into the main one-liner.",
            "The current list name in the top bar will update when the list is loaded.",
        ],
    },
    {
        title: "Saved Query SQ",
        section: "Action Bar [Left Side]",
        keywords: [
            "sq",
            "saved query",
            "save query",
            "load query",
            "rename query",
            "delete query",
            "saved search",
        ],
        questionExamples: ["How do I save my search?", "How do I run a saved query again?"],
        answer: [
            "Press SQ on the left sidebar to open Saved Query.",
            "Enter a query name and save it after running a search you want to keep.",
            "Click a saved query to reload its players.",
            "Saved Query remembers whether the result should use the regular, notes, or reports one-liner.",
        ],
    },
    {
        title: "Alerts",
        section: "Action Bar [Left Side]",
        keywords: ["alert", "alerts", "alert list", "pending alert", "message"],
        questionExamples: ["Where do I see alerts?", "How do alert messages get sent?"],
        answer: [
            "Press A on the left sidebar to open Alerts.",
            "Alerts show player/list items that need attention.",
            "Admins can also send pending alert messages from PurpleMan when that control is available.",
        ],
    },
    {
        title: "Shared Notes SN",
        section: "Action Bar [Left Side]",
        keywords: ["sn", "shared notes", "team note", "note shared"],
        questionExamples: ["Where are shared notes?", "How do I open shared team notes?"],
        answer: [
            "Press SN on the left sidebar to open Shared Notes.",
            "Use it for notes that are shared outside the private player note workflow.",
        ],
    },
    {
        title: "Event Calendar",
        section: "Action Bar [Left Side]",
        keywords: ["calendar", "event calendar", "cal", "schedule", "google calendar"],
        questionExamples: ["Where is the calendar?", "How do I see events?"],
        answer: [
            "Press the calendar icon on the left sidebar.",
            "The event calendar opens in a large window.",
            "You can also set Calendar as your Open on Sign In choice inside PurpleMan.",
        ],
    },
    {
        title: "Legend",
        section: "Action Bar [Left Side]",
        keywords: ["legend", "lg", "codes", "status code", "country code", "school code"],
        questionExamples: ["What does this code mean?", "Where can I look up a school or country code?"],
        answer: [
            "Press LG on the left sidebar to open Legend.",
            "Use Search or Reverse Search to look up status, country, school, and related code meanings.",
        ],
    },
    {
        title: "Bug Report",
        section: "Action Bar [Left Side]",
        keywords: ["bug", "problem", "error", "broken", "report bug", "send bug"],
        questionExamples: ["How do I report a bug?", "Something is broken. What should I do?"],
        answer: [
            "Press the bug button on the left sidebar.",
            "Send the issue with as much detail as possible: what player/list you were on, what button you pressed, and what happened.",
            "For a how-to question, use Common Questions here first; for a broken feature, use Bug Report or Customer Support.",
        ],
    },
    {
        title: "Shrink Or Expand Sidebar",
        section: "Action Bar [Left Side]",
        keywords: ["shrink", "expand", "sidebar", "left menu", "labels"],
        questionExamples: ["How do I expand the left menu labels?", "How do I shrink the sidebar?"],
        answer: [
            "Use the expand/shrink button at the bottom of the left sidebar.",
            "Expanded mode shows longer labels beside the shortcut buttons.",
        ],
    },
    {
        title: "OneLiner Player Rows",
        section: "Main Screen",
        keywords: [
            "one liner",
            "one-line",
            "player row",
            "select player",
            "current player",
            "sort",
            "row",
            "notes one liner",
            "reports one liner",
        ],
        questionExamples: ["How do I choose a player?", "What is the one-liner?"],
        answer: [
            "The one-liner is the main player list in the center of the screen.",
            "Click a row to make that player active.",
            "Most top-bar tools open for the currently active player.",
            "Different searches can switch the row style to regular, notes, or reports depending on the result type.",
        ],
    },
    {
        title: "White Board",
        section: "Top Navigation Buttons",
        keywords: ["white board", "whiteboard", "draftboard", "draft board", "board layout", "tutorial"],
        questionExamples: ["What is White Board?", "Where is the white board?", "What does White Board open?"],
        answer: [
            "Press White Board in the top bar.",
            "White Board is a visual board-building tool for laying out players, headings, pages, priority lists, and board-specific notes.",
            "Use it to organize players on one or more pages, filter who is on the page or board, and share the board with Team Members.",
            "Inside White Board, press the Tutorial button for the full step-by-step walkthrough.",
        ],
    },
    {
        title: "Overview",
        section: "Top Navigation Buttons",
        keywords: ["overview", "all player info", "summary", "reports notes transactions files"],
        questionExamples: ["How do I see everything for one player?", "Where is the quick player summary?"],
        answer: [
            "Press Overview in the top bar.",
            "Overview gives a player-focused summary and lets you jump between Reports, Notes, Transactions, and Files for the active player.",
            "Use it when you want a broad look before opening a specific tool.",
        ],
    },
    {
        title: "Export",
        section: "Top Navigation Buttons",
        keywords: ["export", "csv", "download", "report export", "note export", "screen export"],
        questionExamples: ["How do I export the current screen?", "Can I download reports or notes?"],
        answer: [
            "Press Export in the top bar.",
            "Choose Report Export, Note Export, or Screen Export.",
            "The export downloads a CSV file using the current data for that export type.",
        ],
    },
    {
        title: "Hard Data",
        section: "Top Navigation Buttons",
        keywords: [
            "hard data",
            "hws",
            "height",
            "weight",
            "speed",
            "draft scout",
            "general",
            "measurements",
        ],
        questionExamples: ["Where are height, weight, and speed?", "Where is DraftScout data?"],
        answer: [
            "Press Hard Data in the top bar.",
            "Use General for the main player profile/details.",
            "Use HWS for height, weight, speed, and measurement information.",
            "Use DraftScout for DraftScout-related data when available.",
        ],
    },
    {
        title: "Transactions",
        section: "Top Navigation Buttons",
        keywords: ["transactions", "league history", "status history", "team history", "transaction history"],
        questionExamples: ["Where can I see a player's transaction history?", "How do I filter transactions by league?"],
        answer: [
            "Press Transactions in the top bar.",
            "Transactions shows the active player's league/team/status history.",
            "Click a league button to filter the transaction list by league.",
            "Use History to switch between current transaction view and historical transaction view.",
        ],
    },
    {
        title: "Reports",
        section: "Top Navigation Buttons",
        keywords: [
            "reports",
            "scout reports",
            "new report",
            "grade",
            "grade scale",
            "grade criteria",
            "private report",
            "save report",
        ],
        questionExamples: ["How do I view scout reports?", "Where do I create a report?", "What do the grade buttons do?"],
        answer: [
            "Press Reports in the top bar to open scout reports for the active player.",
            "Use New Report to create a report.",
            "Select an existing report from the report list to view or edit it.",
            "The Grade and Code help buttons show grade scale and grade criteria help.",
            "Use Set Private or Set Public to control report privacy when you have permission.",
        ],
    },
    {
        title: "Notes",
        section: "Top Navigation Buttons",
        keywords: [
            "notes",
            "new note",
            "private note",
            "ask ai",
            "delete note",
            "save note",
            "view notes",
        ],
        questionExamples: ["How do I create a note?", "How do I ask AI for note help?", "How do I make a note private?"],
        answer: [
            "Press Notes in the top bar to open notes for the active player.",
            "Use New Note to create a new note.",
            "Open a note to edit, save, delete, or change privacy when you have permission.",
            "Ask AI can research and draft note text for the active player; review it before saving.",
        ],
    },
    {
        title: "Files",
        section: "Top Navigation Buttons",
        keywords: [
            "files",
            "upload file",
            "player file",
            "team file",
            "pdf",
            "download file",
            "private file",
            "delete file",
        ],
        questionExamples: ["How do I upload a player file?", "Where do I see PDFs or attachments?"],
        answer: [
            "Press Files in the top bar.",
            "Choose Player or Team mode depending on where the file belongs.",
            "Upload a file with a description and privacy setting.",
            "Click a file to preview it when supported, download it, change privacy, or delete it if it is yours.",
        ],
    },
    {
        title: "No Search Results",
        section: "Troubleshooting",
        keywords: ["no results", "blank list", "nothing found", "search failed", "zero records"],
        questionExamples: ["My search found no players.", "Why is the list blank?"],
        answer: [
            "Check whether a top filter or category pill is still active.",
            "Clear the top filter text and click any active orange category pill to turn it off.",
            "In S1 or S2, reset the search fields and try a broader search.",
            "If you loaded a saved query or list, try S3 Last Search or run a fresh S1 search.",
        ],
    },
    {
        title: "Tool Button Missing",
        section: "Troubleshooting",
        keywords: ["button missing", "cannot see reports", "hidden", "show fields", "permission", "admin"],
        questionExamples: ["Why can't I see a button?", "A tool is missing from my screen."],
        answer: [
            "Some buttons are controlled by your account display settings or security level.",
            "Open PurpleMan and check your settings if a tool is hidden.",
            "Some admin-only tools only appear for users with the correct security level.",
            "If you believe you should have access, use Customer Support.",
        ],
    },
    {
        title: "Customer Support Chat",
        section: "Support",
        keywords: ["support", "customer service", "chat", "help", "question mark", "ticket"],
        questionExamples: ["How do I contact support?", "Where is the support chat?"],
        answer: [
            "Press the ? button in the bottom-right corner.",
            "Use Common Questions first for common how-to answers.",
            "Use Customer Support when you need a person to answer or investigate.",
            "Closing a support chat marks the ticket as not open.",
        ],
    },
];
